import { type Alert } from '../types/alert'

export const showAlert = (
  alert: Alert,
  index?: number
): {
  type: string
  payload: {
    alert: Alert
    index: number
  }
} => {
  return {
    type: 'SHOW_ALERT',
    payload: { alert, index: index || 0 }
  }
}

export const hideAlert = (
  index: number
): {
  type: string
  payload: { index: number }
} => {
  return {
    type: 'HIDE_ALERT',
    payload: {
      index: index
    }
  }
}
